// @ts-nocheck

import styled from 'styled-components';

import Formatter from '../../../../i18n/formatter';
import { getCurrency, __ } from '../../../../i18n/l10n';
import NumberFormatter from '../../../../i18n/numberformatter';
import { ItemListSquare } from '../../../../styled-components/shared';

const Wrapper = styled.div`
  font-size: 0.9em;
  padding: 0.6em;
  border-radius: 1em;
  background-image: linear-gradient(230deg, #269dd9cc, #0b2f41f2);
`;

const StyledItemListSquare = styled(ItemListSquare)`
  --itemListSquare--color: #aa0909;
`;

type MPCardDetailsInfoProps = {
  className?: string;
  minBetOdds: number;
  stakeMultiplicator: number;
  maxBet: number;
};

const MPCardDetailsInfo = ({
  className = '',
  minBetOdds = 0,
  stakeMultiplicator = 1,
  maxBet = 50,
}: MPCardDetailsInfoProps) => {
  return (
    <Wrapper className={className}>
      <StyledItemListSquare>
        {__('Minimum odds to win this card: %1$s', NumberFormatter.formatOdd(minBetOdds))}
      </StyledItemListSquare>
      <StyledItemListSquare>
        {__('Freebet win for the complete colour collection: Reference bet x %1$s', stakeMultiplicator)}
      </StyledItemListSquare>
      <StyledItemListSquare>
        {__(
          'C bet: the smallest bet made on this colour collection (max %1$s)',
          Formatter.formatNumber(maxBet, getCurrency(), true),
        )}
      </StyledItemListSquare>
    </Wrapper>
  );
};

export default MPCardDetailsInfo;
